var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-box bgf pad20",staticStyle:{"min-height":"0px"}},[_c('Upload',{attrs:{"action":"/api/file/UploadDocument","on-success":_vm.handleUploadSuc}},[_c('Button',{attrs:{"icon":"ios-cloud-upload-outline"}},[_vm._v("Select the file to upload")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }